<template>
  <div>
    <gmap-map :center="center" :zoom="12" style="width:100%;  height: 500px;">
      <gmap-marker :position="markers" @click="center=markers"></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      center: { lat: 40.8693044, lng: -73.9581164 },
      markers: { lat: 40.8693044, lng: -73.9581164 }
    };
  }
};
</script>

<style lang="scss" scoped>
#map {
  width: 100px;
}
</style>